import React from "react";
import ReactDOM from "react-dom";
import {currentBrowser} from "./tools";
import {
    commentsGet as fetchMessages,
    eventCommentCreate as createMessage,
    commentLikeToggle as likeMessage,
} from "./api";
import KoBridge from "./containers/Messages/KoBridge";

export default class {
    $app = null;

    constructor($app) {
        this.$app = $app;
        this.position = ko.computed(() => this.moduleSettings.position());
        this.isEnabled = ko.computed(() => this.moduleSettings.enabled()
            && !($app.request.getParameter('hideFooter', false) && this.position() === 'bottom')
        );

        $app.once('start', () => {
            if (!this.isEnabled()) {
                return;
            }
            this.render();
        });
    }

    get name() {
        return 'comment';
    }

    get title() {
        return this.$app.require('locale').get(`${this.name}.title`);
    }

    get eventKey() {
        return this.$app.event().eventKey();
    }

    get moduleSettings() {
        const name = 'module' + this.name.substring(0, 1).toUpperCase() + this.name.substring(1);
        return $app.event()[name];
    }

    get roomsKeys () {
        return this.$app.event().stream().map(stream => stream.commentRoom.roomKey())
    }

    fetchMessages(params) {
        return fetchMessages(this.eventKey, {...params, roomsKeys: this.roomsKeys});
    }
    createMessage(data) {
        return createMessage(this.eventKey, data);
    }
    likeMessage(id, like) {
        return likeMessage(this.eventKey, id, like);
    }

    sortMessages(a, b) {
        if (currentBrowser.isMobile() || this.position() === 'top' || this.position() === 'bottom') {
            [a, b] = [b, a];
        }
        if (a.fixed !== b.fixed) {
            return a.fixed - b.fixed;
        }
        return a.time - b.time;
    }
    sortChildren(a, b) {
        return a.time - b.time;
    }

    render() {
        const handleFetchMessages = (params) => this.fetchMessages(params);

        const handleCreateMessage = (data) => this.createMessage({
            streamId: $app.currentStream()?.id(),
            playerTime: $app.require('player').currentTime() + ($app.currentEpisode()?.offset() || 0),
            episodeId: $app.episode()?.id(),
            ...data,
        });

        const handleLikeMessage = (id, like) => {
            const $auth = $app.require('auth');
            const client = $auth.client();
            if (!client) {
                $auth.show();
                return Promise.reject();
            }
            return this.likeMessage(id, like);
        };

        const $ui = this.$app.require('ui');
        const uiTab = new $ui.Tab(this);
        ko.computed(() => uiTab.isShow(this.isEnabled()));
        setTimeout(() => {
            ReactDOM.render(
                <KoBridge
                    $app={this.$app}
                    name={this.name}
                    koEnabled={this.isEnabled}
                    koPosition={this.position}
                    uiTab={uiTab}
                    moduleSettings={this.moduleSettings}
                    allowAnswer={this.moduleSettings.allowAnswer()}
                    sortMessages={this.sortMessages.bind(this)}
                    sortChildren={this.sortChildren.bind(this)}
                    fetchMessages={handleFetchMessages}
                    createMessage={handleCreateMessage}
                    likeMessage={handleLikeMessage}
                    messageFetchLimit={500}
                />,
                document.getElementById(`${this.name}-container`)
            );
        }, 0);
    }
}
